var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:[_vm.$style.circle,( _obj = {}, _obj[_vm.$style.borderRed] = _vm.selectButton, _obj )],on:{"click":function($event){return _vm.$emit('click', _vm.iAmArtist)}}},[_c('i',{class:[_vm.$style.faStyle, _vm.iAmArtist ? 'fa fa-search' : 'fa fa-users']})]),_c('p',{class:_vm.$style.header},[_vm._v(_vm._s(_vm.$t(_vm.iAmArtist ? 'text12' : 'text13')))])])}
var staticRenderFns = []

export { render, staticRenderFns }